var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { HDSIcon } from "@here/hds-react-components/Icon";
import "./noRealmSetup.scss";
import { useSelector } from "react-redux";
import translations from "../../translations/resources/en-GB.json";
var ErrorRealmSetup = function () {
    var errorCode = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.errorCode; });
    var iconStyle = {
        "--hds-icon-color": "var(--hds-warning)",
    };
    var errorObj = {
        401: "Authorization issue",
        404: "These credentials do not authorize access",
        403: "Your credentials do not allow you access to the requested resource.",
        500: "Internal server error",
        503: "Service currently not available",
    };
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "realmSetupBox" }, { children: _jsxs("div", __assign({ className: "errorContainer" }, { children: [_jsx("div", { children: _jsx(HDSIcon, { name: "attention", "icon-style": "outline", size: "40px", style: iconStyle }) }), _jsx("div", __assign({ className: "errorHeadline" }, { children: translations.data["venonboard.realmSetup.errorHeading"] })), _jsxs("div", __assign({ className: "errorSubheading" }, { children: [_jsxs("div", __assign({ className: "errorMessage" }, { children: [errorObj[errorCode], " - Error code: ", errorCode, " "] })), _jsx("div", { children: translations.data["venonboard.realmSetup.errorSubheading"] })] }))] })) })) }));
};
export default ErrorRealmSetup;
